import {inject, injectable} from "inversify";
import {EventEmitter} from "@/modules/base/events";
import {Player} from "@/modules/team/entity";
import {BeforeLineupChangedEndEvent} from "@/modules/team/events/BeforeLineupChangedEndEvent";
import {AfterLineupChangedEndEvent} from "@/modules/team/events/AfterLineupChangedEndEvent";
import {LineupEnum} from "@/modules/base/enums";

@injectable()
export default class LineupHandler {
  constructor(
    @inject(EventEmitter) private em: EventEmitter,
  ) {
  }

  async reset(players: Player[]) {
    await this.em.emitAsync(new BeforeLineupChangedEndEvent);

    await players
      .filter(p => p.lineup !== null)
      .forEachAsync(async (player: Player) => {
        player.lineup = null;
        await player.save();
      });

    await this.em.emitAsync(new AfterLineupChangedEndEvent);
  }

  async remove(player: Player) {
    await this.set([], player, null);
  }

  async set(players: Player[], player: Player, lineup: LineupEnum | null) {
    await this.em.emitAsync(new BeforeLineupChangedEndEvent);

    if (lineup !== null) {
      const linedupPlayer = players.find(p => p.lineup === lineup && !p.equals(player));

      if (linedupPlayer) {
        linedupPlayer.lineup = null;
        await linedupPlayer.save();
      }
    }

    player.lineup = lineup;
    await player.save();

    await this.em.emitAsync(new AfterLineupChangedEndEvent);
  }
}
